import { render, staticRenderFns } from "./InputMultiselect.vue?vue&type=template&id=4afce885&"
import script from "./InputMultiselect.vue?vue&type=script&lang=js&"
export * from "./InputMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports